import { render, staticRenderFns } from "./Dunning.vue?vue&type=template&id=39448faf&"
import script from "./Dunning.vue?vue&type=script&lang=ts&"
export * from "./Dunning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports